import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4 17a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0zm6-4a2 2 0 1 1 4 0v5a2 2 0 1 1-4 0zm6-7a2 2 0 1 1 4 0v12a2 2 0 1 1-4 0z"
    }
  )
);
var SvgMonitoringFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MonitoringFilled_default = SvgMonitoringFilled;

export { MonitoringFilled_default as default };
